import React from "react";
import Prism from "prismjs";
import "../css/prism.css";
import testImage from "../images/mulikaterminal.png";
import Playground from "../componets/Runkit";

function Main() {
  Prism.highlightAll();
  const handeClick = event => {
    event.preventDefault();
    document.getElementById("docs").style.display = `block`;
    document.getElementById("top").style.display = `none`;
  };
  return (
    <main>
      <section id="top" className="flex">
        <section className="top-section">
          <h1>Tiniest JavaScript Test Tool</h1>
          <h2>
            by{" "}
            <a
              className="orange"
              href="https://twitter.com/mayeedwin1"
              target="_blank"
              rel="noopener noreferrer"
            >
              @mayeedwin1
            </a>{" "}
          </h2>
          <span id="show" className="show" onClick={handeClick}>
            Documentation
          </span>
        </section>
        <div className="playground">
          <Playground />
        </div>
      </section>

      <section id="docs" className="fade-in docs">
        <div>
          <h2>Install Mulika</h2>
          <pre>
            <code className="language-javascript">{`npm i mulika`}</code>
          </pre>
        </div>
        <div>
          <h2>Mulika CDN</h2>
          <p>
            Minimal in-browser UI add-on to your pages! Google Chrome, MS Edge
            recommended and Firefox.
          </p>
          <img className="test-image" src={testImage} alt="Logo" />
          <h3>
            Add the scripts above any files to be tested in your html page.
          </h3>
          <pre>
            <code className="language-markup">{`<script src="https://pwafire.org/code/mulika/@latest.js"></script>`}</code>
          </pre>
          <h3>Add styles to your html page.</h3>
          <pre>
            <code className="language-markup">{`<link rel="stylesheet" href="https://pwafire.org/code/mulika/@latest.css" />`}</code>
          </pre>
          <h3>
            Add the html component at the bottom of your html page in the body
            tag, <b>before any scripts in your page</b>.
          </h3>
          <pre>
            <code className="language-markup">{`
    <section id="mulika" class="mulika">
        <div class="top">
            <div class="btns">
                <span class="circle red"></span>
                <span class="circle yellow"></span>
                <span class="circle green"></span>
                <span class="mulika-title">Mulika Tests</span>
            </div>
        </div>
        <pre class="tests" id="tests"></pre>
    </section>
            `}</code>
          </pre>
          <h3>Configuring for in-browser mulika.</h3>
          <p>
            In your test js file, you need to <b>enable debug/dev mode</b> and{" "}
            <b>start mulika</b> first as shown below, all at the top of the test
            file.
          </p>
          <pre>
            <code className="language-javascript">{`
    // Mulika...
    mulika.debug = true;
    mulika.start();
            `}</code>
          </pre>
        </div>

        <div>
          <h2>Specification</h2>
          <p>All variables must be provided, all are required!</p>
          <pre>
            <code className="language-javascript">{`
    // Type check...
    mulika.typeCheck({ type: type, value: value });
            
    // Other tests...   
    mulika.expect(message, value, assertion);
      `}</code>
          </pre>
        </div>
        <section className="footer">
          Project by{" "}
          <a
            href="https://maye.pwafire.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Maye Edwin
          </a>
        </section>
      </section>
    </main>
  );
}

export default Main;
